/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState } from 'react';
import { useTranslation } from "react-i18next";
import {
    Paper,
    Grid,
    Box,
    Tabs,
    Tab,
} from '@mui/material';

import Layout from "../../../components/layout/Layout";
import Form from "./Form"
import Items from "./Items"
import Contact from "./Contact"
import Tarrif from './Tariff';
import { useSelector } from "react-redux";
import { useCanView } from "../../../config/hook/UserPermissions";


function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box>{children}</Box>
            )}
        </div>
    );
}

const NewEdit = () => {
    const [__] = useTranslation("client");
    const [value, setValue] = React.useState(0);
    const [btns, setBtns] = useState(<></>)
    const canView = useCanView();

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    const tabs = [
        {
            label: __(`tabs.orders`),
            component: <Form setBtns={setBtns} __={__} />,
            visible: true, 
        },
        {
            label: __(`tabs.contacts`),
            component: <Contact setBtns={setBtns} __={__} />,
            visible: canView("MAESTROS/CLIENTES/CONTACTOS", "watch"),
        },
        {
            label: __(`tabs.tariff`),
            component: <Tarrif setBtns={setBtns} __={__} />,
            visible: canView("MAESTROS/CLIENTES/CONTACTOS", "watch"), 
        },
    ];

    const visibleTabs = tabs.filter(tab => tab.visible);

    return (
        <Layout
            propsToolbar={{
                title: __(`head.edit.name`),
                srute: __(`head.edit.code`),
            }}
        >
            <Box display="block">
                <Box className="ml-4 mr-0">
                    <Grid className="py-2" container component={Paper} spacing={2}>
                        <Grid item xs={12} lg={6}>
                        <Tabs
                                value={value}
                                onChange={handleChange}
                                variant="scrollable"
                                scrollButtons
                                allowScrollButtonsMobile
                                aria-label="scrollable force tabs example"
                            >
                                {visibleTabs.map((tab, index) => (
                                    <Tab key={index} label={tab.label} />
                                ))}
                            </Tabs>
                        </Grid>
                        <Grid item xs={12} lg={6}>
                            {btns}
                        </Grid>
                    </Grid>
                </Box>
                {visibleTabs.map((tab, index) => (
                    <TabPanel key={index} value={value} index={index}>
                        {tab.component}
                    </TabPanel>
                ))}
            </Box>
        </Layout >
    )
}

export default NewEdit